import React, { useEffect, useState } from 'react';
import InputSelect from '../../Forms/InputSelect.jsx';
import Requestrow from './Requestrow.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Requests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [requestsPerPage] = useState(10);
  const [emailFilter, setEmailFilter] = useState('');
  const [selectedPosition, setSelectedPosition] = useState('');
  const [selectedNationality, setSelectedNationality] = useState('');
  const [conferenceId, setConferenceId] = useState();

  useEffect(() => {
    const controller = new AbortController();

    const fetchRequests = async () => {
      if (!conferenceId) {
        setRequests([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await AxiosClient.get(`/Registeration/${conferenceId}`, {
          signal: controller.signal,
        });
        setRequests(response.data.users || []);
        setCurrentPage(1);
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error('Error fetching requests:', error);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchRequests();
    return () => controller.abort();
  }, [conferenceId]);

  const filteredRequests = requests.filter((request) => (
    (!emailFilter.trim() || (request.email || '').toLowerCase().includes(emailFilter.trim().toLowerCase()))
    && (!selectedPosition || (request.position || '').toLowerCase() === selectedPosition.toLowerCase())
    && (!selectedNationality || (request.nationality || '').toLowerCase() === selectedNationality.toLowerCase())
  ));
  const currentRequests = filteredRequests.slice(
    (currentPage - 1) * requestsPerPage,
    currentPage * requestsPerPage
  );

  return (
    <>
      <PageHeader
        title="Requests"
        description="Review registrations and manage follow-up actions."
      />
      <PageToolbar
        filters={(
          <div className="row g-3 align-items-end w-100">
            <div className="col-xl-3 col-md-6">
              <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="form-label">Search by email</label>
              <input
                type="search"
                className="form-control"
                placeholder="Filter by email"
                value={emailFilter}
                onChange={(event) => {
                  setEmailFilter(event.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-xl-3 col-md-6">
              <InputSelect
                title="Filter by position"
                array={[...new Set(requests.map((item) => item.position).filter(Boolean))]}
                val={selectedPosition}
                setval={(value) => {
                  setSelectedPosition(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-xl-3 col-md-6">
              <InputSelect
                title="Filter by nationality"
                array={[...new Set(requests.map((item) => item.nationality).filter(Boolean))]}
                val={selectedNationality}
                setval={(value) => {
                  setSelectedNationality(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
        )}
        actions={(
          <>
            <ExcelExportButton data={requests} fileName="requests" label="Export all" />
            <ExcelExportButton data={filteredRequests} fileName="filtered_requests" label="Export filtered" />
          </>
        )}
      />

      {loading ? (
        <div className="workspace-loading"><Loader label="Loading requests..." /></div>
      ) : !conferenceId ? (
        <div className="workspace-empty">Select a conference to view its requests.</div>
      ) : (
        <>
          <DataTable>
            <thead>
              <tr>
                <th>Image</th>
                <th>Full Name</th>
                <th>Position</th>
                <th>Nationality</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentRequests.length > 0 ? currentRequests.map((request) => (
                <Requestrow key={request.id} req={request} />
              )) : (
                <tr>
                  <td colSpan="6" className="workspace-empty">No requests match these filters.</td>
                </tr>
              )}
            </tbody>
          </DataTable>

          {filteredRequests.length > requestsPerPage && (
            <nav className="workspace-pagination" aria-label="Request pages">
              <ul className="pagination mb-0">
                {Array.from({ length: Math.ceil(filteredRequests.length / requestsPerPage) }, (_, index) => (
                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(index + 1)}
                      aria-current={currentPage === index + 1 ? 'page' : undefined}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </>
      )}
    </>
  );
};

export default Requests;